module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-row', {
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', [_c('date-range-picker', {
    model: {
      value: (_vm.reportRange),
      callback: function($$v) {
        _vm.reportRange = $$v
      },
      expression: "reportRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadReport()
      }
    }
  }, [_c('span', [_vm._v("Generuj XLS")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "download"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Numer umowy")]), _vm._v(" "), _c('th', [_vm._v("Data zawarcia")]), _vm._v(" "), _c('th', [_vm._v("Nazwa klienta")]), _vm._v(" "), _c('th', [_vm._v("Kwota (" + _vm._s(_vm.currency.name) + ")")]), _vm._v(" "), _c('th', [_vm._v("Prowizja")]), _vm._v(" "), _c('th', [_vm._v("% netto (" + _vm._s(_vm.currency.name) + ")")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.list), function(item) {
    return [_vm._l((item.agreements), function(agreement) {
      return _c('tr', [_c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(agreement.fullNumber))]), _vm._v(" "), _c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(_vm._f("date")(agreement.date.date)))]), _vm._v(" "), _c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(agreement.customerName))]), _vm._v(" "), _c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(_vm._f("amountFormat")(agreement.amount)))]), _vm._v(" "), _c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(agreement.commission) + "%")]), _vm._v(" "), _c('td', {
        staticClass: "td-no_link"
      }, [_vm._v(_vm._s(_vm._f("amountFormat")(agreement.commissionAmount)) + " ")])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "tr-summary"
    }, [_c('td', {
      staticClass: "td-no_link",
      attrs: {
        "colspan": "3"
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_c('strong', [_vm._v(_vm._s(_vm._f("amountFormat")(item.totalAmount)))])]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link",
      attrs: {
        "colspan": "2"
      }
    })])]
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "tr-summary"
  }, [_c('td', {
    staticClass: "td-no_link text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Suma")]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.items.totalAmount)) + " ")])]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.items.totalCommission)) + " ")])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8f36f3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/Sales.vue
// module id = 808
// module chunks = 0